import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const baseUrl = "api/v1/websalud/primeraars";

const tipoCoberturaContratadaPssUrl = `${baseUrl}/prestadores/coberturas/contratadas/tipos`;

const coberturaContratadaPssUrl = `${baseUrl}/prestadores/coberturas/contratadas`;

const obtenerDatosPssUrl = `${baseUrl}/prestadores/generales`;

const obtenerTiposCoberturasUrl = `${baseUrl}/coberturas/tipos`;

const obtenerCoberturasUrl = `${baseUrl}/coberturas`;

const obtenerCoberturaDocumentosUrl = `${baseUrl}/coberturas/documentos`;

const guardarCoberturaDocumentosUrl = (
  tipoProcedimiento,
  cobertura,
  compania
) =>
  cobertura
    ? `${obtenerCoberturaDocumentosUrl}?tipoProcedimiento=${tipoProcedimiento}&cobertura=${cobertura}&codigoCompania=${compania}`
    : `${obtenerCoberturaDocumentosUrl}?tipoProcedimiento=${tipoProcedimiento}&codigoCompania=${compania}`;

const obtenerCoberturasConfiguradasPssUrl = `${baseUrl}/coberturas/pss/configuradas`;

const obtenerCoberturasConfiguradasDocumentosUrl = (
  cobertura,
  tipoProcedimiento
) =>
  `${baseUrl}/coberturas/${cobertura}/${tipoProcedimiento}/configuradas/documentos`;

const obtenerTipoCoberturaContratadaPss = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    tipoCoberturaContratadaPssUrl,
    request
  );
  return response.data;
};

const obtenerCoberturaContratadaPss = async (request) => {
  const { numeroPagina = 1, tamanoPagina = 20, ...rest } = request;

  const requestWithPagination = {
    ...rest,
    numeroPagina,
    tamanoPagina
  };

  const response = await InterceptToken(
    BaseApi.get,
    coberturaContratadaPssUrl,
    requestWithPagination
  );
  return response.data;
};

const obtenerDatosPss = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    obtenerDatosPssUrl,
    request
  );
  return response.data;
};

const guardarCoberturaContratadaPss = async (request) => {
  const response = await InterceptToken(
    BaseApi.post,
    coberturaContratadaPssUrl,
    request
  );
  return response.data;
};

const obtenerTiposCoberturas = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    obtenerTiposCoberturasUrl,
    request
  );
  return response.data;
};

const obtenerCoberturas = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    obtenerCoberturasUrl,
    request
  );
  return response.data;
};

const obtenerCoberturaDocumentos = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    obtenerCoberturaDocumentosUrl,
    request
  );
  return response.data;
};

const guardarCoberturaDocumentos = async (request) => {
  const response = await InterceptToken(
    BaseApi.post,
    guardarCoberturaDocumentosUrl(
      request.tipoProcedimiento,
      request.cobertura,
      request.compania
    ),
    request
  );
  return response.data;
};

const obtenerCoberturasConfiguradasPss = async (request) => {
  const response = await InterceptToken(
    BaseApi.get,
    obtenerCoberturasConfiguradasPssUrl,
    request
  );
  return response.data;
};

const obtenerCoberturasConfiguradasDocumentos = async (request) => {
  const { cobertura, tipoProcedimiento } = request;

  const response = await InterceptToken(
    BaseApi.get,
    obtenerCoberturasConfiguradasDocumentosUrl(cobertura, tipoProcedimiento)
  );
  return response.data;
};

const CoberturaService = {
  obtenerTipoCoberturaContratadaPss,
  obtenerCoberturaContratadaPss,
  obtenerDatosPss,
  guardarCoberturaContratadaPss,
  obtenerTiposCoberturas,
  obtenerCoberturas,
  obtenerCoberturaDocumentos,
  guardarCoberturaDocumentos,
  obtenerCoberturasConfiguradasPss,
  obtenerCoberturasConfiguradasDocumentos
};

export default CoberturaService;
